import React, { useState } from "react"
import styled from "styled-components"
import { navigate } from "gatsby"

import { Device } from "../../types/contentfulTypes"

import * as TextStyles from "../styles/TextStyles"
import CollectionsCarousel from "./CollectionsCarousel"
import ColorChip from "../buttons/ColorChip"
import ExpandButton from "../buttons/ExpandButton"

interface Props {
  collection: Device
}

interface StyledProps {
  length?: number
}

const CollectionList = (props: Props) => {
  const { collection } = props
  const [isShow, setIsShow] = useState(false)

  const colors = collection.mockups?.map(mockup => mockup.color)

  const images = collection.mockups?.flatMap(mockup => mockup.images)

  return (
    <Wrapper>
      <HeaderWrapper>
        <Container>
          <Title id="device-name" onClick={() => navigate(`/mockups/${collection.slug}`)}>
            {collection.name}
          </Title>
          <div onClick={() => setIsShow(!isShow)}>
            <ExpandButton isShow={isShow} />
          </div>
        </Container>
        <ColorChipsWrapper length={colors?.length}>
          {colors?.map((color, index) => (
            <ColorChip key={index} color={color} platform={collection.platform} />
          ))}
        </ColorChipsWrapper>
      </HeaderWrapper>
      {images?.length > 0 && isShow && <CollectionsCarousel images={images} />}
    </Wrapper>
  )
}

export default CollectionList

const Wrapper = styled.div`
  display: grid;
  gap: 40px;

  #device-name {
    cursor: pointer;
  }
`

const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: start;
  gap: 10px;
  padding: 0 20px;

  @media (max-width: 730px) {
    grid-template-columns: auto;
    justify-content: start;
  }
`

const Container = styled.div`
  display: grid;
  width: fit-content;
  grid-template-columns: auto auto;
  gap: 20px;
  align-items: start;
`

const Title = styled(TextStyles.H4)`
  width: fit-content;
  font-weight: 600;
  font-size: 28px;
  line-height: 33px;
`

export const ColorChipsWrapper = styled.div<StyledProps>`
  display: grid;
  max-width: 700px;
  width: fit-content;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(30px, auto));

  @media (max-width: 1100px) {
    max-width: 350px;
  }

  @media (max-width: 520px) {
    max-width: 280px;
  }
`
